import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../api/axios";
import { useSnackbar } from "../../utils/SnackbarProvider";

export default function ForgotPassword() {
  const location = useLocation();
  const navigate = useNavigate();

  const [step, setStep] = useState(1); // 1: username, 2: OTP, 3: reset
  const [username, setUsername] = useState("");
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const { showSnackbar } = useSnackbar();
  /* =========================
     PREFILL FROM LOGIN
  ========================= */
  useEffect(() => {
    if (location.state?.username) {
      setUsername(location.state.username);
      fetchUser(location.state.username);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
  let interval;

  if (step === 2 && timer > 0) {
    interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);
  } else if (timer === 0) {
    setCanResend(true);
  }

  return () => clearInterval(interval);
}, [step, timer]);
  /* =========================
     FETCH USER DETAILS
  ========================= */
  const fetchUser = async (username) => {
    try {
      const res = await api.get(`/users/profile/${username}`);
      setPhone(res.data.user.mobile);
    } catch (err) {
      console.error(err);
    }
  };

  /* =========================
     SEND OTP
  ========================= */
  const sendOtp = async () => {
  try {
    const res = await api.post("/users/forgot-password/send-otp", {
      username,
    });

    setPhone(res.data.phone);
    setStep(2);

    // 🔥 RESET TIMER
    setTimer(30);
    setCanResend(false);

  } catch (err) {
    // alert(err.response?.data?.message || "Failed to send OTP");
     showSnackbar(err.response?.data?.message || "Failed to send OTP", "error");
  }
};

const resendOtp = async () => {
  try {
    await sendOtp();
  } catch (err) {
    showSnackbar("Failed to resend OTP", "error");
  }
};

  /* =========================
     VERIFY OTP
  ========================= */
  const verifyOtp = async () => {
    try {
      await api.post("/users/forgot-password/verify-otp", {
        username,
        otpCode: otp,
      });

      setStep(3);
    } catch (err) {
      showSnackbar("Invalid OTP", "error");
    }
  };

  /* =========================
     RESET PASSWORD
  ========================= */
  const resetPassword = async () => {
    try {
      await api.post("/users/forgot-password/reset", {
        username,
        password,
      });

      showSnackbar("Password updated successfully", "success");
      navigate("/login");
    } catch (err) {
      showSnackbar("Failed to reset password", "error");
    }
  };

  const maskPhone = (phone) => {
  if (!phone) return "";
  return phone.slice(0, 2) + "****" + phone.slice(-2);
};
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f3f3f3",
      }}
    >
      <Paper sx={{ p: 3, width: 400 }}>
        <Typography variant="h6" mb={2}>
          Forgot Password
        </Typography>

        {/* STEP 1 */}
        {step === 1 && (
          <>
            <TextField
              fullWidth
              label="Email or Mobile"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              sx={{ mb: 2 }}
            />
            <Button fullWidth variant="contained"
            sx={{
              backgroundColor: "#ff9900",
              color: "#fff",
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "20px",
              py: 1,
              "&:hover": { backgroundColor: "#ff8800" },
            }}
            onClick={sendOtp}>
              Send OTP
            </Button>
          </>
        )}

        {/* STEP 2 */}
        {step === 2 && (
  <>
    <Typography sx={{ mb: 1 }}>
      OTP sent to {maskPhone(phone)}
    </Typography>

    <TextField
      fullWidth
      label="Enter OTP"
      value={otp}
      onChange={(e) => setOtp(e.target.value)}
      sx={{ mb: 2 }}
    />

    <Button fullWidth variant="contained" 
    sx={{
              backgroundColor: "#ff9900",
              color: "#fff",
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "20px",
              py: 1,
              "&:hover": { backgroundColor: "#ff8800" },
            }}
    onClick={verifyOtp}>
      Verify OTP
    </Button>

    {/* ⏳ TIMER / RESEND */}
    <Typography
      sx={{
        mt: 2,
        fontSize: 13,
        color: canResend ? "#0066c0" : "gray",
        cursor: canResend ? "pointer" : "default",
        textAlign: "center",
      }}
      onClick={canResend ? resendOtp : undefined}
    >
      {canResend
        ? "Resend OTP"
        : `Resend OTP in ${timer}s`}
    </Typography>
  </>
)}

        {/* STEP 3 */}
        {step === 3 && (
          <>
            <TextField
              fullWidth
              label="New Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ mb: 2 }}
            />

            <Button fullWidth variant="contained" 
            sx={{
              backgroundColor: "#ff9900",
              color: "#fff",
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "20px",
              py: 1,
              "&:hover": { backgroundColor: "#ff8800" },
            }}
            onClick={resetPassword}>
              Reset Password
            </Button>
          </>
        )}
      </Paper>
    </Box>
  );
}